import React from 'react';
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import CustomLink from '../../CustomLink/CustomLink';
import { PreNavItem } from '../PreNav/PreNav.interface';
import SideNavAccordionHeading from './SideNavAccordionHeading';

const PreNavAccordionItem: React.FC<PreNavItem> = ({
  label,
  link,
  dropdown,
  ...props
}) => {
  return (
    <AccordionItem key={props._uid} uuid={props._uid} className="group w-full">
      <AccordionItemHeading>
        <AccordionItemButton className="focus:ring-0 focus:outline-none">
          <AccordionItemState>
            {(state) =>
              state && (
                <SideNavAccordionHeading
                  label={label}
                  link={link}
                  state={state}
                />
              )
            }
          </AccordionItemState>
        </AccordionItemButton>
      </AccordionItemHeading>

      <AccordionItemPanel className="px-10 border-b border-border/light">
        <ul className="space-y-2 pb-4 pt-4">
          {dropdown &&
            !!dropdown.length &&
            dropdown.map(({ label, link, _uid }) => (
              <li key={_uid}>
                <CustomLink
                  url={link?.cached_url}
                  label={label}
                  className="nav-link font-normal text-text/body hover:text-text/body-accent block py-2 transition-all"
                >
                  {label}
                </CustomLink>
              </li>
            ))}
        </ul>
      </AccordionItemPanel>
    </AccordionItem>
  );
};

export default PreNavAccordionItem;
